"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_date_math_1 = require("@progress/kendo-date-math");
var TimePart_1 = require("./models/TimePart");
var utils_1 = require("../utils");
var setter = function (method) { return function (date, value) {
    var clone = kendo_date_math_1.cloneDate(date);
    clone[method](value);
    return clone;
}; };
var defaultGetters = [
    { type: TimePart_1.TIME_PART.hour, getter: function (value) { return value.getHours(); } },
    { type: TimePart_1.TIME_PART.minute, getter: function (value) { return value.getMinutes(); } },
    { type: TimePart_1.TIME_PART.second, getter: function (value) { return value.getSeconds(); } },
    { type: TimePart_1.TIME_PART.millisecond, getter: function (value) { return value.getMilliseconds(); } }
];
var left = function (getter) { return function (origin, _) { return getter(origin); }; };
var right = function (getter) { return function (_, candidate) { return getter(candidate); }; };
var convertToObject = function (parts) { return parts.reduce(function (obj, p) { obj[p.type] = p.type; return obj; }, {}); };
var getterByPart = function (parts) { return function (g) { return parts[g.type] ? right(g.getter) : left(g.getter); }; };
var gettersFactory = function (getters) { return function (parts) { return (getters.map(getterByPart(convertToObject(parts)))); }; };
var snapValue = function (getter, step, min, type) { return function (date) {
    var value = getter(date);
    var minValue = getter(min);
    if (type === 'hour') {
        return value - ((value - minValue) % step);
    }
    if (date.getTime() <= min.getTime()
        && value !== 0
        && value <= minValue) {
        return (Math.ceil(value / step)) * step;
    }
    return value - (value % step);
}; };
var snappersFactory = function (getters) { return function (steps, min) { return (getters.map(function (g) {
    var step = Math.floor(steps[g.type]);
    return step ? snapValue(g.getter, step, min, g.type) : g.getter;
})); }; };
/**
 * @hidden
 */
exports.generateGetters = gettersFactory(defaultGetters);
/**
 * @hidden
 */
exports.generateSnappers = snappersFactory(defaultGetters);
/**
 * @hidden
 */
exports.valueMerger = function (getters) { return function (origin, candidate) {
    origin.setHours.apply(origin, getters.map(function (g) { return g(origin, candidate); }));
    return origin;
}; };
/**
 * @hidden
 */
exports.snapTime = function (snappers) { return function (candidate) {
    var date = kendo_date_math_1.cloneDate(candidate);
    date.setHours.apply(date, snappers.map(function (s) { return s(date); }));
    return date;
}; };
/**
 * @hidden
 */
exports.setHours = setter('setHours');
/**
 * @hidden
 */
exports.setMinutes = setter('setMinutes');
/**
 * @hidden
 */
exports.setSeconds = setter('setSeconds');
/**
 * @hidden
 */
exports.getNow = function () { return new Date(); };
/**
 * @hidden
 */
exports.range = function (start, end, step) {
    if (step === void 0) { step = 1; }
    var result = [];
    for (var i = start; i < end; i = i + step) {
        result.push(i);
    }
    return result;
};
var normalizeTimes = function (candidate, min, max) { return ({
    candidateValue: utils_1.setTime(utils_1.MIDNIGHT_DATE, candidate),
    maxValue: kendo_date_math_1.addDays(utils_1.setTime(utils_1.MIDNIGHT_DATE, max), min.getHours() < max.getHours() ? 0 : 1),
    minValue: utils_1.setTime(utils_1.MIDNIGHT_DATE, min)
}); };
/**
 * @hidden
 */
exports.timeInRange = function (candidate, min, max) {
    if (!candidate || !min || !max) {
        return candidate;
    }
    var _a = normalizeTimes(candidate, min, max), candidateValue = _a.candidateValue, minValue = _a.minValue, maxValue = _a.maxValue;
    if (candidateValue < minValue) {
        return utils_1.setTime(candidate, min);
    }
    if (candidateValue > maxValue) {
        return utils_1.setTime(candidate, max);
    }
    return candidate;
};
/**
 * @hidden
 */
exports.isInTimeRange = function (candidate, min, max) {
    if (!candidate || !min || !max) {
        return true;
    }
    var _a = normalizeTimes(candidate, min, max), candidateValue = _a.candidateValue, minValue = _a.minValue, maxValue = _a.maxValue;
    return minValue <= candidateValue && candidateValue <= maxValue;
};
/**
 * @hidden
 */
exports.isInRange = function (candidate, min, max) {
    if (candidate === null) {
        return true;
    }
    var _a = normalizeTimes(candidate, min, max), candidateValue = _a.candidateValue, minValue = _a.minValue, maxValue = _a.maxValue;
    return minValue <= candidateValue && candidateValue <= maxValue;
};
/**
 * @hidden
 */
exports.isSmallerThanMin = function (val, min) {
    if (val === null || min === null) {
        return false;
    }
    var normalizedValue = utils_1.setTime(utils_1.MIDNIGHT_DATE, val);
    var normalizedMin = utils_1.setTime(utils_1.MIDNIGHT_DATE, min);
    return normalizedValue.getTime() < normalizedMin.getHours();
};
/**
 * @hidden
 */
exports.isBiggerThanMax = function (val, max) {
    if (val === null || max === null) {
        return false;
    }
    var normalizedValue = utils_1.setTime(utils_1.MIDNIGHT_DATE, val);
    var normalizedMax = utils_1.setTime(utils_1.MIDNIGHT_DATE, max);
    return normalizedMax.getTime() < normalizedValue.getHours();
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dateinputs@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_r_2yelhkp6sdgaltctm3m4k3bqy4/~/@progress/kendo-react-dateinputs/dist/npm/timepicker/utils.js
// module id = 51
// module chunks = 0